import L from "leaflet";
import cn from "classnames";

import st from "./control.module.scss";

// 'topleft' | 'topright' | 'bottomleft' | 'bottomright'

class Controls {
  map: any
  
  constructor(map: any) {
    this.map = map
    this.init = this.init.bind(this)
    this.addDrawControl = this.addDrawControl.bind(this)
    
  }
  
  init(events: any) {
    this.addDrawControl(events)
    this.changeZoomControl()
  }
  
  addDrawControl({polygonEditor, pointEditor, clear}: any) {
    // @ts-ignore
    L.Control.RemoveDraw = L.Control.extend({
      options: {
        position: 'topright'
      },
      onAdd: (map: any) => {
        let container = L.DomUtil.create('div', cn('leaflet-bar leaflet-control', st.leaflet_custom_container));
        
        let button1 = L.DomUtil.create('a', cn('leaflet-control-button', st.leaflet_custom_control), container);
        button1.innerText = "Редактор полигона"
        L.DomEvent.disableClickPropagation(button1);
        L.DomEvent.on(button1, 'click', function () {
          polygonEditor()
        });
        
        let button3 = L.DomUtil.create('a', cn('leaflet-control-button', st.leaflet_custom_control), container);
        button3.innerText = "Редактор точек для заданий"
        L.DomEvent.disableClickPropagation(button3);
        L.DomEvent.on(button3, 'click', function () {
          pointEditor()
        });
        
        let button4 = L.DomUtil.create('a', cn('leaflet-control-button', st.leaflet_custom_control), container);
        button4.innerText = "Выключить редактор"
        L.DomEvent.disableClickPropagation(button4);
        L.DomEvent.on(button4, 'click', function () {
          clear()
        });
        
        container.title = "Title";
        return container;
      },
      onRemove: (map: any) => {
      },
    });
    // @ts-ignore
    let control = new L.Control.RemoveDraw()
    // control.addTo(this.map);
  }
  
  changeZoomControl() {
    L.DomUtil.addClass(this.map.zoomControl.getContainer(), st.zoom_middle_right)
  }
  
  // @ts-ignore
  // this.map.zoomControl.setPosition('middleleft');
  
  // You can also put other controls in the same placeholder.
  //@ts-ignore
  // L.control.scale({position: 'middleleft'}).addTo(this.map);
  
  
  // addControlPlaceholders = (map: any) => {
  //   let corners = map._controlCorners,
  //     l = 'leaflet-',
  //     container = map._controlContainer;
  //
  //   function createCorner(vSide: any, hSide: any) {
  //     let className = l + vSide + ' ' + l + hSide;
  //
  //     corners[vSide + hSide] = L.DomUtil.create('div', className, container);
  //   }
  //
  //   createCorner('verticalcenter', 'left');
  //   createCorner('verticalcenter', 'right');
  // }
  
  
  // addControlDraw() {
  //   // @ts-ignore
  //   L.Control.Draw = L.Control.extend({
  //     options: {
  //       position: 'topright'
  //     },
  //     onAdd: (map: any) => {
  //       let container = L.DomUtil.create('div', cn('leaflet-bar leaflet-control', st.leaflet_custom_container));
  //       let button = L.DomUtil.create('a', cn('leaflet-control-button', st.leaflet_custom_control), container);
  //       button.innerText = "Draw"
  //       L.DomEvent.disableClickPropagation(button);
  //       L.DomEvent.on(button, 'click', function () {
  //         console.log('click');
  //       });
  //       container.title = "Title";
  //       return container;
  //     },
  //     onRemove: (map: any) => {
  //     },
  //   });
  //   // @ts-ignore
  //   let control = new L.Control.Draw()
  //   control.addTo(this.map);
  // }
  //
  // addCustomControl() {
  //   // @ts-ignore
  //   L.Control.Custom = L.Control.extend({
  //     options: {
  //       position: '',
  //     },
  //     onAdd: (map: any) => {
  //       let controlElementTag = 'div';
  //       let controlElementClass = 'my-leaflet-control';
  //       let controlElement = L.DomUtil.create("div", controlElementClass);
  //
  //       // Continue implementing the control here.
  //
  //       return controlElement;
  //     }
  //   })
  //   // @ts-ignore
  //   let control = new L.Control.Custom()
  //   control.addTo(this.map);
  // }

//   L.Map.include({
//                   _initControlPos: function () {
//   let corners: any = this._controlCorners = {},
//   l = 'leaflet-',
//   container = this._controlContainer =
//     L.DomUtil.create('div', l + 'control-container', this._container);
//
//   function createCorner(vSide: any, hSide: any) {
//     let className = l + vSide + ' ' + l + hSide;
//
//     corners[vSide + hSide] = L.DomUtil.create('div', className, container);
//   }
//
//   createCorner('top', 'left');
//   createCorner('top', 'right');
//   createCorner('bottom', 'left');
//   createCorner('bottom', 'right');
//
//   createCorner('top', 'center');
//   createCorner('middle', 'center');
//   createCorner('middle', 'left');
//   createCorner('middle', 'right');
//   createCorner('bottom', 'center');
// }
// });
  
}

export default Controls;